import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Col, Drawer, Form, Input, Row, Space, message } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import { createSubcat } from "../../../../api/subcats";

export default function CreateSubcat({ isVisible, setVisible, selected }: any) {
  const { id } = selected;

  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: createSubcat,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["categories", id] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const { name, count } = await form.validateFields();
    const data = {
      name,
      count: Number(count),
      is_active: true,
      category_id: Number(id),
    };
    mutate({ data });
  };

  return (
    <Drawer
      title={`Create Subcategory`}
      placement={"right"}
      width={500}
      closable={false}
      onClose={() => setVisible(false)}
      open={isVisible}
      extra={
        <Space>
          <Button danger onClick={() => setVisible(false)}>
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <Form
          id="createSubcat"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter name",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="count"
                label="Count"
                rules={[
                  {
                    required: true,
                    message: "Please enter count",
                  },
                ]}
              >
                <Input placeholder="Count" />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="border-0 bg-blue-600 text-white mr-2"
                loading={isLoading}
              >
                Submit
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  form.resetFields();
                }}
              >
                Reset
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </Drawer>
  );
}
